
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/budgets",
      function () {
        return require("private-next-pages/budgets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/budgets"])
      });
    }
  